import update from 'immutability-helper'
import {
  ChannelChildCommentsQuery,
  ChannelChildCommentsQueryVariables,
  NewsItemComment_NewsCommentEdgeFragment,
} from 'generated/graphql'

export const getLastCursor = (
  edges?: NewsItemComment_NewsCommentEdgeFragment[],
) => {
  if (!edges || edges.length === 0) return undefined
  return edges[edges.length - 1]
    ? edges[edges.length - 1].cursor || undefined
    : undefined
}

export const ChannelChildCommentsUpdateQuery: (
  previousQueryResult: ChannelChildCommentsQuery,
  options: {
    fetchMoreResult?: ChannelChildCommentsQuery | undefined
    variables?: ChannelChildCommentsQueryVariables | undefined
  },
) => ChannelChildCommentsQuery = (previousQueryResult, { fetchMoreResult }) => {
  if (!fetchMoreResult) return previousQueryResult
  return update(previousQueryResult, {
    comments: {
      edges: {
        $push: fetchMoreResult.comments.edges,
      },
      pageInfo: {
        $set: fetchMoreResult.comments.pageInfo,
      },
    },
  })
}
